import * as FIELD_NAME from 'constant/form-item-names'
import { connect } from 'react-redux'
import React from 'react'
import PropTypes from 'prop-types'
import { Form } from 'antd'
import UserTypeSelect from 'view/component/form-items/user-type-select'

const CategoryUserTypeSelect = ({ userTypes }) => {
  const handleUpdate = (prevValues, currentValues) => prevValues.special !== currentValues.special
  return (
    <Form.Item
      noStyle
      shouldUpdate={handleUpdate}
    >
      {({ getFieldValue }) => {
        const special = getFieldValue(FIELD_NAME.SPECIAL)
        return !special
        ? <UserTypeSelect userTypes={userTypes} />
        : null
      }}

    </Form.Item>
  )
}

CategoryUserTypeSelect.propTypes = {
  userTypes: PropTypes.array
}

const mapStateToProps = ({ user, category }, { categoryUuid }) => ({
  userTypes: categoryUuid
    ? (category.managementCategories.find(({ uuid }) => uuid === categoryUuid)).user_types
    : user.userTypes
})

export default connect(mapStateToProps)(CategoryUserTypeSelect)
